const getters = {
    userinfo: state => state.app.userinfo,
    village: state => state.app.village,
    identity: state => state.app.identity,
};
export default getters
